import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  FETCH_TABLE_SUCCESS,
  UPDATE_PRICING_OPTIONS_SELECTED,
  UPDATE_CATEGORIES_SELECTED,
  UPDATE_FILTERS,
  SET_PRICING_OPTIONS_LOADING,
  SET_CATEGORIES_LOADING,
  SET_UPDATES_LOADING,
  SET_FILTERS_DIRTY,
  SET_LOADING,
  SET_MODULE_LOGIC
} from "./membershipLengthSagas";

export const initialState = {
  currentUser: {},
  isLoading: true,
  initialRequest: false,
  isPricingOptionsLoading: false,
  isCategoriesLoading: false,
  filtersDirty: false,
  updatesLoading: false,
  date: "",
  table: {},
  filters: {
    agreement_statuses: [],
    pricing_options: [],
    membership_types: [],
    group_by: [],
    categories: [],
    types: [],
    member_statuses: []
  },
  moduleLogicOptions: [
    { id: "agreements", name: "Agreement" },
    { id: "members", name: "Member" }
  ],
  selectedModuleLogic: { id: "agreements", name: "Agreement" },
  selectedFilters: {
    type: { id: "membership_type", name: "Membership Type" },
    agreement_status: { id: "all_agreements", name: "All Agreements" },
    group_by: { id: "pricing_options", name: "Sales Packages" },
    membership_types: [],
    pricing_options: [],
    member_status: { id: "all_members", name: "All Members" }
  }
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_MODULE_LOGIC]: (state, action) => ({
      ...state,
      selectedModuleLogic: action.payload
    }),
    [SET_CATEGORIES_LOADING]: (state, action) => ({
      ...state,
      isCategoriesLoading: action.payload
    }),
    [SET_PRICING_OPTIONS_LOADING]: (state, action) => ({
      ...state,
      isPricingOptionsLoading: action.payload
    }),
    [UPDATE_CATEGORIES_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        categories: [...action.payload]
      }
    }),
    [UPDATE_PRICING_OPTIONS_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        pricing_options: [...action.payload]
      }
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [UPDATE_FILTERS]: (state, { payload }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, ...payload }
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    [FETCH_TABLE_SUCCESS]: (state, action) => ({
      ...state,
      table: { ...action.payload }
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload,
      selectedFilters: {
        ...initialState.selectedFilters,
        categories: action.payload.categories,
        pricing_options: action.payload.pricing_options,
        membership_types: action.payload.membership_types
      }
    })
  },

  initialState
);
